"use strict"

const angular = require("angular");

angular
    .module("Agnes")
    .factory("$messageBox", [
        "$modal",
        function ($modal) {
            var $messageBox = {};

            // Shows confirm modal window
            $messageBox.showConfirm = function (title, text, buttonText) {
                return $modal.open({
                    template: require("../Templates/MessageBox.html"),
                    controller: "MessageBoxController",
                    resolve: {
                        title: function () {
                            return title;
                        },
                        text: function () {
                            return text;
                        },
                        buttonText: function () {
                            return buttonText;
                        }
                    }
                });
            };

            return $messageBox;
        }
    ])
    
    .factory("$messageBox", [
        "$uibModal",
        function ($uibModal) {
            var $messageBox = {};

            // Shows confirm modal window
            $messageBox.showConfirm = function (title, text, buttonText) {
                return $uibModal.open({
                    template: require("../Templates/MessageBox.html"),
                    controller: "MessageBoxController",
                    resolve: {
                        title: function () {
                            return title;
                        },
                        text: function () {
                            return text;
                        },
                        buttonText: function () {
                            return buttonText;
                        }
                    }
                });
            };

            return $messageBox;
        }
    ]);